import firebase from "firebase/app";
import { giftCollection } from "@/firebase";
import { giftCategoryCollection } from "@/firebase";
import { imageTemplateCollection } from "@/firebase";
import { v4 as uuidv4 } from "uuid";
import { storage } from "@/firebase";
import store from "@/store";
import * as c from "@/constants";

const state = {
  gift: [],
  giftCat: [],
  getTemplateDimensions: {},
};

const getters = {};

const actions = {
  // eslint-disable-next-line
  saveTemplateDimensions({ commit }) {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      //console.log(state.getTemplateDimensions);
      giftCollection
        .doc(state.getTemplateDimensions.id)
        .update({
          printSizeArray: state.getTemplateDimensions.printSizeArray,
        })
        .then(() => {
          console.log("Edited record.");
          resolve();
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  getTemplateDimensions({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log(payload);
      imageTemplateCollection
        .where("client", "==", payload.client)
        .where("module", "==", payload.module)
        .where("code", "==", payload.code)
        .limit(1)
        .get()
        .then((querySnapshot) => {
          let tempData = [];
          // če ni zadetkov, pogledamo ali imamo morda template izven našega client-a (private=false)
          // sicer pa procesiramo normalno naše najdene template 
          if (querySnapshot.empty) {
            imageTemplateCollection
              .where("module", "==", payload.module)
              .where("private", "==", false)
              .where("code", "==", payload.code)
              .limit(1)
              .get()
              .then((querySnapshot2) => {
                querySnapshot2.forEach((doc2) => {
                  tempData = {
                    width: doc2.data().width,
                    height: doc2.data().height,
                    imageAspectRatio: doc2.data().width / doc2.data().height,
                    id: payload.id,
                    aId: payload.aId,
                    printSizeArray: payload.printSizeArray,
                    code: payload.code,
                  };
                });
                resolve(commit("getTemplateDimensions", tempData));
              })
              .catch(function (error) {
                reject(console.log("Error getting documents: ", error));
              });
          } else {
            querySnapshot.forEach((doc) => {
              tempData = {
                width: doc.data().width,
                height: doc.data().height,
                imageAspectRatio: doc.data().width / doc.data().height,
                id: payload.id,
                aId: payload.aId,
                printSizeArray: payload.printSizeArray,
                code: payload.code,
              };
            });
            resolve(commit("getTemplateDimensions", tempData));
          }
        })
        .catch(function (error) {
          reject(console.log("Error getting documents: ", error));
        });
    });
  },
  getGift({ commit }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.mode == "live") {
        giftCollection
          .where("client", "==", payload.client)
          .where("active", "==", true)
          .orderBy("order", "asc")
          .orderBy("name", "asc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            resolve(commit("getGift", tempData));
          })
          .catch(function (error) {
            reject(console.log("Error getting documents: ", error));
          });
      } else if (payload.mode == "giftCategory") {
        giftCollection
          .where("client", "==", payload.client)
          .where("active", "==", true)
          .where("giftCategory", "==", payload.giftCategory)
          .orderBy("order", "asc")
          .orderBy("name", "asc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            resolve(commit("getGift", tempData));
          })
          .catch(function (error) {
            reject(console.log("Error getting documents: ", error));
          });
      } else if (payload.mode == "price") {
        giftCollection
          .where("client", "==", payload.client)
          .where("active", "==", true)
          .orderBy("giftCategory", "asc")
          .orderBy("name", "asc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              giftCategoryCollection
                .where("client", "==", payload.client)
                .where("active", "==", true)
                .where("name", "==", doc.data().giftCategory)
                .limit(1)
                .get()
                .then((querySnapshot2) => {
                  querySnapshot2.forEach((doc2) => {
                    if (doc2.data().superCategory == payload.superCategory)
                      tempData.push(Object.assign(doc.data(), { id: doc.id }));
                  })
                  resolve(commit("getGift", tempData));
                })
            });
          })
          .catch(function (error) {
            reject(console.log("Error getting documents: ", error));
          });
      } else
        giftCollection
          .where("client", "==", payload.client)
          .orderBy("order", "asc")
          .orderBy("name", "asc")
          .get()
          .then((querySnapshot) => {
            let tempData = [];
            querySnapshot.forEach((doc) => {
              tempData.push(Object.assign(doc.data(), { id: doc.id }));
            });
            resolve(commit("getGift", tempData));
          })
          .catch(function (error) {
            reject(console.log("Error getting documents: ", error));
          });
    });
  },
  getGiftCat({ commit }, payload) {
    return new Promise((resolve, reject) => {
      giftCollection
        .where("client", "==", payload.client)
        .where("giftCategory", "==", payload.name)
        .where("active", "==", true)
        .orderBy("order", "asc")
        .orderBy("name", "asc")
        .get()
        .then((querySnapshot) => {
          let tempData = [];
          querySnapshot.forEach((doc) => {
            const copy = doc.data();

            let arr = store.state.storePromoCode.activePromoCodes.filter(
              (x) => x.module == c.G_MODULE_PHOTO_GIFT && !x.hidden && x.item == doc.id
            );

            if (typeof copy.enableDeviceBasedEdit === 'undefined') {
              Object.assign(copy, { enableDeviceBasedEdit: false }); // dodamo podatek, če še ne obstaja v bazi              
            }

            if (arr.length > 0) {
              tempData.push(Object.assign(copy, { id: doc.id, discount: arr[0] }));
            } else tempData.push(Object.assign(copy, { id: doc.id }));
          });
          resolve(commit("getGiftCat", tempData));
        }).catch(function (error) {
          reject(console.log("Error: ", error));
        });
    });
  },
  addGift({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order);
      payload.price = Number(payload.price);
      payload.minOrder = Number(payload.minOrder);
      payload.maxTemplateClones = Number(payload.maxTemplateClones);
      payload.overrideSizeWidth = Number(payload.overrideSizeWidth);
      payload.overrideSizeHeight = Number(payload.overrideSizeHeight);

      if (payload.image !== undefined) {
        let uploadPath = "gift/" + payload.client + "-" + uuidv4();

        payload.imageURL = uploadPath;
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                giftCollection
                  .add(payload)
                  .then((docRef) => {
                    console.log("Added record.");
                    resolve(
                      commit(
                        "addGift",
                        Object.assign(payload, { id: docRef.id })
                      )
                    );
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      } else {
        payload.image = "";
        giftCollection
          .add(payload)
          .then((docRef) => {
            console.log("Added record.");
            resolve(
              commit("addGift", Object.assign(payload, { id: docRef.id }))
            );
          })
          .catch((error) => {
            reject(console.log(error));
          });
      }
    });
  },
  removeGift({ commit }, payload) {
    return new Promise((resolve, reject) => {
      giftCollection
        .doc(payload)
        .delete()
        .then(() => {
          resolve(commit("removeGift", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  editGift({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log(payload);
      payload.order = Number(payload.order); // String => Number      
      payload.price = Number(payload.price);
      payload.minOrder = Number(payload.minOrder);
      payload.maxTemplateClones = Number(payload.maxTemplateClones);
      payload.overrideSizeWidth = Number(payload.overrideSizeWidth);
      payload.overrideSizeHeight = Number(payload.overrideSizeHeight);

      if (payload.image == undefined) {
        payload.image = payload.image2;
        delete payload.image2;
        giftCollection
          .doc(payload.id)
          .set(payload, { merge: true })
          .then(() => {
            resolve(commit("editGift", payload));
          })
          .catch((error) => {
            reject(console.log(error));
          });
      } else {
        let uploadPath = "";
        if (payload.image2.length <= 0) {
          // edit, prejšnje stanje brez slike (add v storage)
          uploadPath = "gift/" + payload.client + "-" + uuidv4();
          //console.log(uploadPath);
          payload.imageURL = uploadPath;
        } else {
          // edit, prejšnje stanje s sliko (replace v storage)
          uploadPath = payload.imageURL;
        }
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                delete payload.image2;
                giftCollection
                  .doc(payload.id)
                  .set(payload, { merge: true })
                  .then(() => {
                    resolve(commit("editGift", payload));
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      }
    });
  },
  // eslint-disable-next-line
  addGiftType({ commit }, payload) {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order);
      payload.inventory = Number(payload.inventory);
      payload.price = Number(payload.price);
      payload.id = uuidv4();

      let item = state.gift.filter((x) => {
        return x.id == payload.recordId;
      });

      let arr = [];
      if (item[0].typeArray) {
        arr = item[0].typeArray;
      }
      arr.push(payload);
      arr.sort((a, b) => (parseInt(a.order) > parseInt(b.order) ? 1 : -1));

      if (payload.image !== undefined) {
        let uploadPath = "giftType/" + payload.client + "-" + uuidv4();

        payload.imageURL = uploadPath;
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                giftCollection
                  .doc(payload.recordId)
                  .update({
                    typeArray: arr,
                  })
                  .then(() => {
                    resolve();
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      } else {
        payload.image = "";

        giftCollection
          .doc(payload.recordId)
          .update({
            typeArray: arr,
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(console.log(error));
          });
      }
    });
  },
  // eslint-disable-next-line
  addGiftPrintSize({ commit }, payload) {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order);
      payload.id = uuidv4();

      let item = state.gift.filter((x) => {
        return x.id == payload.recordId;
      });

      let arr = [];
      if (item[0].printSizeArray) {
        arr = item[0].printSizeArray;
      }

      // generiramo subarray s kodami, ki vsebuje še koordinate
      let cArray = [];
      Array.from(payload.codes.split("|")).forEach((x) => {
        cArray.push({
          code: x,
          coordinates: { top: 0, left: 0, width: 0, height: 0, angle: 0 },
        });
      });
      payload.codesArray = cArray;

      //console.log(payload);
      arr.push(payload);
      arr.sort((a, b) => (parseInt(a.order) > parseInt(b.order) ? 1 : -1));

      if (payload.image !== undefined) {
        let uploadPath = "giftPrintSize/" + payload.client + "-" + uuidv4();

        payload.imageURL = uploadPath;
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                giftCollection
                  .doc(payload.recordId)
                  .update({
                    printSizeArray: arr,
                  })
                  .then(() => {
                    resolve();
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      } else {
        payload.image = "";

        giftCollection
          .doc(payload.recordId)
          .update({
            printSizeArray: arr,
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(console.log(error));
          });
      }
    });
  },
  // eslint-disable-next-line
  editGiftPrintSize({ commit }, payload) {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order);

      // kateri zapis
      let item = state.gift.filter((x) => {
        return x.id == payload.recordId;
      });

      // printSizeArray zapisa
      item = item[0].printSizeArray;
      // stari codesArray, ki ga rabim za pregledovanje
      let cCodes = item[0].codesArray;
      console.log(cCodes);
      // izbrišemo stari printSizeArray
      let arr = item.filter((x) => {
        return x.id !== payload.id;
      });

      // generiramo subarray s kodami, ki vsebuje še koordinate
      let cArray = [];
      Array.from(payload.codes.split("|")).forEach((x) => {
        // obstoječe kode napolnimo ponovno, da se ne resetirajo na 0 ampak ostanejo enake
        let arr2 = cCodes.filter((y) => {
          return y.code == x;
        });
        if (arr2.length > 0) {
          cArray.push({
            code: x,
            coordinates: {
              top: arr2[0].coordinates.top,
              left: arr2[0].coordinates.left,
              width: arr2[0].coordinates.width,
              height: arr2[0].coordinates.height,
              angle: arr2[0].coordinates.angle,
            },
          });
        } else
          cArray.push({
            code: x,
            coordinates: {
              top: 0,
              left: 0,
              width: 0,
              height: 0,
              angle: 0,
            },
          });
      });
      payload.codesArray = cArray;

      // dodamo novega
      arr.push(payload);
      arr.sort((a, b) => (parseInt(a.order) > parseInt(b.order) ? 1 : -1)); // in sortiramo

      if (payload.image == undefined) {
        payload.image = payload.image2;
        delete payload.image2;

        giftCollection
          .doc(payload.recordId)
          .update({
            printSizeArray: arr,
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(console.log(error));
          });
      } else {
        let uploadPath = "";
        if (payload.image2.length <= 0) {
          // edit, prejšnje stanje brez slike (add v storage)
          uploadPath = "giftPrintSize/" + payload.client + "-" + uuidv4();
          payload.imageURL = uploadPath;
        } else uploadPath = payload.imageURL; // edit, prejšnje stanje s sliko (replace v storage)

        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                delete payload.image2;
                giftCollection
                  .doc(payload.recordId)
                  .update({
                    printSizeArray: arr,
                  })
                  .then(() => {
                    resolve();
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      }
    });
  },
  // eslint-disable-next-line
  removeGiftPrintSize({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let arr = payload.item.printSizeArray;

      arr = payload.item.printSizeArray.filter((x) => {
        return x.id !== payload.id;
      });

      arr.sort((a, b) => (parseInt(a.order) > parseInt(b.order) ? 1 : -1));

      if (payload.imageURL.length > 0) {
        const ref = firebase
          .storage()
          .ref()
          .child(payload.imageURL);
        ref
          .delete()
          .then(function () {
            giftCollection
              .doc(payload.item.id)
              .update({
                printSizeArray: arr,
              })
              .then(() => {
                resolve();
              })
              .catch((error) => {
                reject(console.log(error));
              });
          })
          .catch(function (error) {
            reject(console.log(error));
          });
      } else
        giftCollection
          .doc(payload.item.id)
          .update({
            printSizeArray: arr,
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(console.log(error));
          });
    });
  },
  // eslint-disable-next-line
  deleteGiftPrintSizeImage({ commit }, payload) {
    let eArray = [];
    Array.from(payload.item.printSizeArray).forEach((x) => {
      if (x.id == payload.item2.id) {
        x.image = "";
        x.imageURL = "";
        x.imageAspectRatio = 0;
        x.imageHeight = 0;
        x.imageWidth = 0;
        x.order = Number(payload.item2.order); // String => Number
      }
      eArray.push(x);
    });

    payload.item.printSizeArray = eArray;
    //console.log(payload.item);

    giftCollection
      .doc(payload.item.id)
      .set(payload.item, { merge: true })
      .then(() => {
        console.log("Edited record.");
        commit("editGift", payload.item);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  // eslint-disable-next-line
  editGiftType({ commit }, payload) {
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      payload.order = Number(payload.order);
      payload.inventory = Number(payload.inventory);
      payload.price = Number(payload.price);

      // kateri zapis
      let item = state.gift.filter((x) => {
        return x.id == payload.recordId;
      });

      // typeArray zapisa
      item = item[0].typeArray;

      // izbrišemo stari typeArray
      let arr = item.filter((x) => {
        return x.id !== payload.id;
      });
      // dodamo novega
      arr.push(payload);
      arr.sort((a, b) => (parseInt(a.order) > parseInt(b.order) ? 1 : -1)); // in sortiramo

      if (payload.image == undefined) {
        payload.image = payload.image2;
        delete payload.image2;

        giftCollection
          .doc(payload.recordId)
          .update({
            typeArray: arr,
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(console.log(error));
          });
      } else {
        let uploadPath = "";
        if (payload.image2.length <= 0) {
          // edit, prejšnje stanje brez slike (add v storage)
          uploadPath = "giftType/" + payload.client + "-" + uuidv4();
          payload.imageURL = uploadPath;
        } else uploadPath = payload.imageURL; // edit, prejšnje stanje s sliko (replace v storage)

        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);

        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function () {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function (downloadURL) {
                payload.image = downloadURL;
                delete payload.image2;
                giftCollection
                  .doc(payload.recordId)
                  .update({
                    typeArray: arr,
                  })
                  .then(() => {
                    resolve();
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      }

      /*
      
      if (payload.image !== undefined) {
        let uploadPath = "giftType/" + payload.client + "-" + uuidv4();
  
        payload.imageURL = uploadPath;
        let storageRef = storage.ref(uploadPath);
        let uploadTask = storageRef.put(payload.image);
  
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, {
          complete: function() {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(function(downloadURL) {
                payload.image = downloadURL;
                giftCollection
                  .doc(payload.recordId)
                  .update({
                    typeArray: arr,
                  })
                  .then(() => {
                    resolve();
                  })
                  .catch((error) => {
                    reject(console.log(error));
                  });
              });
          },
        });
      } else {
        payload.image = "";
  
        giftCollection
          .doc(payload.recordId)
          .update({
            typeArray: arr,
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(console.log(error));
          });
      }*/
    });
  },

  // eslint-disable-next-line
  changeGiftInventory({ commit }, payload) {
    return new Promise((resolve) => {
      if (!payload.itemSimpleType) {
        giftCollection
          .where("id", "==", payload.itemId)
          .limit(1)
          .get()
          .then((qs2) => {
            if (!qs2.empty) {
              qs2.forEach((doc) => {
                if (doc.data().typeArray.length > 0) {
                  let tTypeArray = doc.data().typeArray;
                  let item = tTypeArray.filter((x) =>
                    x.id == payload.itemTypeId
                  );

                  // prištejemo zalogo nazaj, če ni nastavljena kot neomejena (-1)
                  if (item[0].inventory > -1) item[0].inventory = Number(item[0].inventory) + payload.num;

                  const index = tTypeArray.findIndex((x) => x.id == payload.itemTypeId);
                  tTypeArray.splice(index, 1, item[0]);

                  giftCollection
                    .doc(payload.itemId)
                    .update({
                      typeArray: tTypeArray,
                    })
                    .then(() => {
                      resolve(true);
                    })
                    .catch((error) => {
                      console.log(error);
                      resolve(false);
                    });

                  console.log(tTypeArray);
                  resolve(true);
                } else resolve(false);
              });
            } else resolve(false);
          });
      } else resolve(false);
    });
  },

  // eslint-disable-next-line
  removeGiftType({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let arr = payload.item.typeArray;

      arr = payload.item.typeArray.filter((x) => {
        return x.id !== payload.id;
      });

      arr.sort((a, b) => (parseInt(a.order) > parseInt(b.order) ? 1 : -1));

      if (payload.imageURL.length > 0) {
        const ref = firebase
          .storage()
          .ref()
          .child(payload.imageURL);
        ref
          .delete()
          .then(function () {
            giftCollection
              .doc(payload.item.id)
              .update({
                typeArray: arr,
              })
              .then(() => {
                resolve();
              })
              .catch((error) => {
                reject(console.log(error));
              });
          })
          .catch(function (error) {
            reject(console.log(error));
          });
      } else
        giftCollection
          .doc(payload.item.id)
          .update({
            typeArray: arr,
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            reject(console.log(error));
          });
    });
  },
  // eslint-disable-next-line
  removeImageLinkFromGift({ commit }, payload) {
    console.log(payload);
    return new Promise((resolve, reject) => {
      payload.image = ""; payload.imageURL = "";
      giftCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGift", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleGiftBooleanActive({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.active = !payload.active;
      giftCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGift", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleGiftBooleanAllowTemplateClones({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.allowTemplateClones = !payload.allowTemplateClones;
      giftCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGift", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleGiftBooleanAllowCustomSize({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.allowCustomSize = !payload.allowCustomSize;
      giftCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGift", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleGiftBooleanOverrideSize({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.overrideSize = !payload.overrideSize;
      giftCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGift", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleGiftBooleanEnableSmallDevices({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.enableSmallDevices = !payload.enableSmallDevices;
      giftCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGift", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
  // eslint-disable-next-line
  toggleGiftBooleanEnableDeviceBasedEdit({ commit }, payload) {
    return new Promise((resolve, reject) => {
      payload.enableDeviceBasedEdit = !payload.enableDeviceBasedEdit;
      giftCollection
        .doc(payload.id)
        .set(payload, { merge: true })
        .then(() => {
          resolve(commit("editGift", payload));
        })
        .catch((error) => {
          reject(console.log(error));
        });
    });
  },
};

const mutations = {
  getTemplateDimensions(state, payload) {
    state.getTemplateDimensions = payload;
    //console.log("TA", state.getTemplateDimensions);
  },
  getGift(state, payload) {
    state.gift = payload;
    //console.log("getGift", state.gift);
  },
  getGiftCat(state, payload) {
    state.giftCat = payload;
    //console.log(state.giftCat);
  },
  addGift(state, payload) {
    state.gift.push(payload);
  },
  removeGift(state, payload) {
    const index = state.gift.findIndex((item) => item.id == payload);
    state.gift.splice(index, 1);
  },
  editGift(state, payload) {
    const index = state.gift.findIndex((item) => item.id == payload.id);
    state.gift.splice(index, 1, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
